import React, { useState, useEffect } from 'react';
import './SoundControls.css';

const SoundControls = () => {
  const [isMuted, setIsMuted] = useState(false);
  const [volume, setVolume] = useState(0.7);
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);

  // Load saved volume from localStorage
  useEffect(() => {
    const savedVolume = localStorage.getItem('gameVolume');
    const savedMuted = localStorage.getItem('gameMuted');
    
    if (savedVolume !== null) {
      setVolume(parseFloat(savedVolume));
    }
    
    if (savedMuted !== null) {
      setIsMuted(savedMuted === 'true');
    }
    
    // Apply initial volume
    applyVolume(parseFloat(savedVolume || 0.7), savedMuted === 'true');
  }, []);

  // Apply volume to audio elements
  const applyVolume = (vol, muted) => {
    const audioElements = document.querySelectorAll('audio, video');
    const actualVolume = muted ? 0 : vol;
    
    audioElements.forEach(audio => {
      audio.volume = actualVolume;
    });
    
    // Update CSS variables for sound effects
    document.documentElement.style.setProperty('--game-volume', actualVolume);
  };

  // Save and apply volume
  useEffect(() => {
    localStorage.setItem('gameVolume', volume.toString());
    localStorage.setItem('gameMuted', isMuted.toString());
    applyVolume(volume, isMuted);
  }, [volume, isMuted]);

  const toggleMute = () => {
    setIsMuted(!isMuted);
  };

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    setVolume(newVolume);
    if (isMuted && newVolume > 0) {
      setIsMuted(false);
    }
  };

  const getVolumeIcon = () => {
    if (isMuted || volume === 0) return '🔇';
    if (volume < 0.3) return '🔈';
    if (volume < 0.7) return '🔉';
    return '🔊';
  };

  return (
    <div 
      className="sound-controls-container"
      onMouseEnter={() => setShowVolumeSlider(true)}
      onMouseLeave={() => setShowVolumeSlider(false)}
    >
      <button 
        className="sound-toggle-btn"
        onClick={toggleMute}
        title={isMuted ? "Unmute sound" : "Mute sound"}
      >
        {getVolumeIcon()}
      </button>
      
      <div className={`volume-slider-container ${showVolumeSlider ? 'visible' : ''}`}>
        <input
          type="range"
          min="0"
          max="1"
          step="0.1"
          value={isMuted ? 0 : volume}
          onChange={handleVolumeChange}
          className="volume-slider"
        />
        <div className="volume-value">
          {Math.round((isMuted ? 0 : volume) * 100)}%
        </div>
      </div>
    </div>
  );
};

export default SoundControls;